module.exports = __webpack_public_path__ + "static/media/2project.5bb757ed.jpeg";